var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlipYAxis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8ACCA1",
    d: "M24.5,20.856c1.235,0,2.5,1,2.5,2.235v2.235c0,1.233-1.266,2.234-2.5,2.234c-1.234,0-2.5-1.001-2.5-2.234 v-2.235C22,21.856,23.265,20.856,24.5,20.856z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8ACCA1",
    d: "M24.5,30.54c1.235,0,2.5,1,2.5,2.234v2.235c0,1.234-1.266,2.234-2.5,2.234c-1.234,0-2.5-1-2.5-2.234v-2.235 C22,31.54,23.265,30.54,24.5,30.54z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8ACCA1",
    d: "M24.5,40.225c1.235,0,2.5,1,2.5,2.234v2.234c0,1.235-1.266,2.235-2.5,2.235c-1.234,0-2.5-1-2.5-2.235v-2.234 C22,41.225,23.265,40.225,24.5,40.225z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.3755,
    y1: 13.6782,
    x2: 23.3755,
    y2: 35.1831
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#407A60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#005443"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M41.751,24.43c0,6.129-7.707,10.752-18.4,10.752c-5.323,0-10.351-1.21-13.351-3.309v0.9 c0,1.235-1.266,2.235-2.5,2.235s-2.5-1-2.5-2.235V26h11.733c1.235,0,2.235,0.766,2.235,2s-1,2-2.235,2h-0.917 c2.15,1,4.609,0.814,7.176,0.814c8.179,0,14.289-3.367,14.289-6.333c0-2.967-6.11-6.31-14.289-6.31 c-4.521,0-8.726,0.986-11.535,2.729c-1.049,0.651-2.427,0.322-3.077-0.727c-0.65-1.047-0.328-2.429,0.72-3.08 c3.498-2.17,8.561-3.416,13.892-3.416C33.687,13.678,41.751,18.3,41.751,24.43z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#8ACCA1",
    d: "M24.5,1.488c1.235,0,2.5,1,2.5,2.235v2.235c0,1.234-1.266,2.234-2.5,2.234c-1.234,0-2.5-1-2.5-2.234V3.723 C22,2.488,23.265,1.488,24.5,1.488z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#8ACCA1",
    d: "M24.5,11.172c1.235,0,2.5,1,2.5,2.235v2.235c0,1.234-1.266,2.235-2.5,2.235c-1.234,0-2.5-1.001-2.5-2.235 v-2.235C22,12.172,23.265,11.172,24.5,11.172z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlipYAxis);
export default __webpack_public_path__ + "static/media/flip_y_axis.72c0649b6072b0f493525e9c3c773f4e.svg";
export { ForwardRef as ReactComponent };